import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.css'],
    standalone: false
})
export class ForgetPasswordComponent {

  message: string = '';
  loading: boolean = false;
  email: any

  success: boolean = false;

  constructor(public utility: UtilitiesService,
    private router: Router, private api: ApiService) { this.utility.show = false; }

  getPassword() {
    this.loading = true;

    const sub = this.api.get_empty('login/forgotpassword/' + this.email).subscribe(
      async data => {

        this.message = "Email sent to your email address."
        this.success = true;
        //this.router.navigate(['login']);
      },
      async error => {
        this.message = "Error: Cannot connect!";
      }
    );

    sub.add(() => { this.loading = false; });
  }
}
